export default "__VITE_ASSET__HlM8SaGd__"